import { BehaviorSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { FREQ_BEHAVIOR, BEHAVIOR_ITEMS, classifyBehavior } from "./helpers";

export default function Step3Behaviors({ answers, onChange, allAnswered, behaviorScore, errors }) {
  const behaviorClass = allAnswered ? classifyBehavior(behaviorScore) : null;

  return (
    <div>
      <BehaviorSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        ¿Con qué frecuencia aplican estas situaciones a ti?
      </div>

      {BEHAVIOR_ITEMS.map((item) => (
        <div key={item.id} className="mb-4">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold" style={{ color: "#2D2A24" }}>{item.label}</span>
            {item.inverse && (
              <span
                className="text-[9px] font-bold px-2 py-0.5 rounded-lg shrink-0"
                style={{ background: "#FFF3DC", color: "#F9A01B" }}
                data-testid={`f4-tag-behavior-${item.id}`}
              >
                a limitar
              </span>
            )}
          </div>
          <PillSelect
            options={FREQ_BEHAVIOR.map((f) => f)}
            value={answers[item.id] ?? ""}
            onChange={(v) => onChange(item.id, v)}
            error={errors?.getError(`behavior_${item.id}`)}
            testId={`f4-behavior-${item.id}`}
          />
        </div>
      ))}

      {allAnswered && behaviorClass && (
        <CalculatedBadge
          label="Conductas alimentarias"
          value={`${behaviorScore}/15`}
          category={behaviorClass.label}
          categoryColor={behaviorClass.color}
          testId="badge-conductas"
        />
      )}
    </div>
  );
}
